module.exports = __webpack_public_path__ + "static/media/professional-teaching-ad1.82414661.png";